import { useAuth } from '../../contexts/AuthContext'
import StatCard from "../../components/StatCard";
import StudentPerformance from "../../components/StudentPerformance";
import ClassPerformanceChart from "../../components/ClassPerformanceChart";
import UsageCard from "../../components/UsageCard";
import { performanceData, students, statsData, usageData } from "../../components/EducatorDasbordData";

import { useEffect, useState } from "react";

function EducatorDashboard() {
  const { user, getAllDashboardData } = useAuth()
  const [dashboardPerformanceTrend, setDashboardPerformanceTrend] = useState([])
  const [dashboardStudentPerformanceTop, setDashboardStudentPerformanceTop] = useState([])
  const [dashboardStudentPerformanceNeed, setDashboardStudentPerformanceNeed] = useState([])
  const [dashboardUsageSummary, setDashboardUsageSummary] = useState([])
  const [loader, setLoader] = useState(false)
  // const [allData , setAllData]=useState([])

  useEffect(() => {
    getDashboardData()
  }, [])


  const getDashboardData = async () => {
    try {
      setLoader(true)
      const response = await getAllDashboardData()
      if (response?.success == true) {
        setLoader(false)
        setDashboardPerformanceTrend(response?.data?.weekList)
        setDashboardStudentPerformanceTop(response?.data?.user_performance?.TopPerformers)
        setDashboardStudentPerformanceNeed(response?.data?.user_performance?.NeedsAttention)
        setDashboardUsageSummary(response?.data?.applications)
        // setAllData(response?.data)
      } else {
        setLoader(false)
        setDashboardPerformanceTrend([])
        setDashboardStudentPerformanceTop([])
        setDashboardStudentPerformanceNeed([])
        setDashboardUsageSummary([])
      }
    } catch (error) {
      setLoader(false)
      console.error('Error fetching dashboard data:', error)
    }
  }
  // const handleExport = () => {
  //   if (!allData) {
  //     alert('No data available to export');
  //     return;
  //   }

  //   const csvSections = [];

  //   // Helper function to convert array → CSV
  //   const convertArrayToCSV = (data, sectionName) => {
  //     if (!data || !data.length) return '';
  //     const headers = Object.keys(data[0]);
  //     const rows = data.map(row =>
  //       headers.map(h => `"${(row[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')
  //     );
  //     return `\n\n"${sectionName.toUpperCase()}"\n${headers.join(',')}\n${rows.join('\n')}`;
  //   };

  //   // Applications section
  //   if (Array.isArray(allData.applications) && allData.applications.length > 0) {
  //     csvSections.push(convertArrayToCSV(allData.applications, 'Applications'));
  //   }

  //   // Users section
  //   if (Array.isArray(allData.usersList) && allData.usersList.length > 0) {
  //     csvSections.push(convertArrayToCSV(allData.usersList, 'Users'));
  //   }

  //   // Stats section (object → one-row CSV)
  //   if (allData.stats && Object.keys(allData.stats).length > 0) {
  //     const headers = Object.keys(allData.stats);
  //     const values = headers.map(h => `"${(allData.stats[h] ?? '').toString().replace(/"/g, '""')}"`);
  //     csvSections.push(`\n\n"STATS"\n${headers.join(',')}\n${values.join(',')}`);
  //   }

  //   const finalCSV = csvSections.join('\n');

  //   // Download
  //   const blob = new Blob([finalCSV], { type: 'text/csv;charset=utf-8;' });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', `dashboard_export_${new Date().toISOString().slice(0, 10)}.csv`);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Educator Dashboard - Welcome, {user?.full_name}!
        </h1>
        <p className="text-gray-600">Manage your students and track their progress</p>
      </div>
      {/* <div className='flex gap-2'> */}
      {/* <button className="bg-[#71757633] text-[#717576] px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
            <FunnelIcon className='w-5 h-5 text-[#717576] mt-[2px]' /> Filter  </button> */}
      {/* <button  
              onClick={handleExport}
            className="bg-brandBlue text-white px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
            <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
            </svg>
            </span> Export  </button> */}
      {/* </div> */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">

        {statsData.map((stat) => (
          <StatCard
            key={stat.id}
            icon={stat.icon}
            title={stat.title}
            value={stat.value}
            arrowColor={stat.arrowColor}
            link={stat.link}   // ✅ add this
            onclick={stat.onclick}
          // setState={setOpenInquiryForm}

          />
        ))}

      </div>


      {/* <div className="card">
        <div className="card-header">
          <h3 className="text-lg font-medium">Student Progress Overview</h3>
        </div>
        <div className="card-body">
          <p className="text-gray-600">Student progress tracking will be displayed here.</p>
        </div>
      </div> */}


      <div className="grid md:grid-cols-2 gap-6  ">
        <div>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-[#717576]">
              Class Performance Trend
            </h2>
            <select
              className="border rounded-lg px-3 py-2 text-sm text-gray-600 focus:outline-none focus:ring-0"
            >
              <option>Last 30 days</option>
              <option>Last 60 days</option>
              <option>Last 90 days</option>
            </select>

          </div>

          <ClassPerformanceChart data={dashboardPerformanceTrend} />
        </div>
        <div>
          <StudentPerformance top={dashboardStudentPerformanceTop} need={dashboardStudentPerformanceNeed} loader={loader} />
        </div>
      </div>


      <div className="bg-white shadow rounded-2xl p-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-6">
          Application Usage Summary
        </h2>
        {loader ?
          <div className="h-[225px] flex items-center justify-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
          </div>
          :
          (dashboardUsageSummary && dashboardUsageSummary.length > 0) ?
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {dashboardUsageSummary.map((app, index) => (
                <UsageCard key={index} {...app} />
              ))}
            </div>
            :
            <div className="text-center h-[225px] content-center">
              <p className="text-gray-400 text-sl">There are currently no application usage summary.</p>
            </div>
        }
      </div>


    </div>
  )
}

export default EducatorDashboard